import { render, staticRenderFns } from "./OutstandingPartListView.vue?vue&type=template&id=56af0064"
import script from "./OutstandingPartListView.vue?vue&type=script&lang=js"
export * from "./OutstandingPartListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56af0064')) {
      api.createRecord('56af0064', component.options)
    } else {
      api.reload('56af0064', component.options)
    }
    module.hot.accept("./OutstandingPartListView.vue?vue&type=template&id=56af0064", function () {
      api.rerender('56af0064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/outstandingpart/OutstandingPartListView.vue"
export default component.exports